import * as Utils from '../libraries/Utils';
import { get } from 'lodash';
import { formatPriceZero } from '../libraries/Utils';
export const ReceiptLineDescriptionEnum = {
    Config: 'Config',
    Aggregation: 'Aggregation',
    Discount: 'Discount',
    Info: 'Info',
    Product: 'Product',
    UnselectedOption: 'UnselectedOption',
    ReturnableItem: 'ReturnableItem',
    Pant: 'Pant',
    Voucher: 'Voucher',
    SelectedOption: 'SelectedOption',
};
const discountTypeLocalization = {
    SunsetPlusForEmployees: 'Medarbejderrabat',
    SunsetPlusBasic: 'SunsetPLUS rabat',
    SunsetPlusBasicAnnual: 'SunsetPLUS rabat',
    SunsetPlusExclusive: 'SunsetPLUS rabat',
    SunsetPlusExclusiveAnnual: 'SunsetPLUS rabat',
    SunsetPlusBusiness: 'SunsetPLUS rabat',
    SunsetPlusPremium: 'SunsetPLUS rabat',
    SunsetPlusPremiumAnnual: 'SunsetPLUS rabat',
    CartDiscount: 'Rabat',
};
function getTextRaw(line, i18n) {
    const { name } = line;
    const { text } = line;
    const defaultName = text || name;
    if (i18n) {
        return getEffectiveName(defaultName, line, i18n);
    }
    return defaultName;
}
const getEffectiveName = (defaultName, line, i18n) => {
    if (!i18n) {
        return defaultName;
    }
    if (defaultName === 'Pant') {
        return translate(defaultName, i18n, 'common.pant');
    }
    if ('productId' in line) {
        return translate(defaultName, i18n, `product.${line.productId}.name`);
    }
    if ('optionIndex' in line) {
        return translate(defaultName, i18n, `productConfiguration.${line.configId}.options[${line.optionIndex}].name`);
    }
    if ('productIds' in line) {
        if (line.productIds.length === 1) {
            return translate(defaultName, i18n, `product.${line.productIds[0]}.name}`);
        }
        const arrayOfTranslatedString = [];
        line.productIds.forEach((productId) => {
            arrayOfTranslatedString.push(translate('translationMissing', i18n, `product.${productId}.name`));
        });
        if (arrayOfTranslatedString.includes('translationMissing')) {
            return line;
        }
        return arrayOfTranslatedString.join(' & ');
    }
    return defaultName;
};
const translate = (defaultValue, i18n, key) => {
    if (i18n) {
        const value = get(i18n.messages[i18n.locale], key, defaultValue);
        if (value) {
            return value;
        }
    }
    return defaultValue;
};
const transformDescriptionLineToDescription = (line, i18n) => {
    const getFields = (line) => {
        const fields = {};
        if (line.quantity)
            fields.quantity = line.quantity;
        if (line.price)
            fields.price = line.price;
        if (line.totalVat)
            fields.totalVat = line.totalVat;
        if (line.vatCategoryId)
            fields.vatCategoryId = line.vatCategoryId;
        if (line.vatCategoryName)
            fields.vatCategoryName = line.vatCategoryName;
        if (line.vatReference)
            fields.vatReference = line.vatReference;
        if (line.vatRatePerMille)
            fields.vatRatePerMille = line.vatRatePerMille;
        return fields;
    };
    const indent = line.indent;
    const type = ReceiptLineDescriptionEnum;
    switch (line.type) {
        case 'Aggregation':
            return Object.assign({ text: getText(line), textRaw: getTextRaw(line), indent }, getFields(line));
        case 'Product':
            return Object.assign(Object.assign({ text: line.isAddon
                    ? `${translate('', i18n, 'utilityComponents.addons.upgradedTo')} ${getText(line, true, i18n)}`
                    : getText(line, true, i18n), textRaw: getTextRaw(line), indent }, getFields(line)), { productId: line.productId, productIds: line.productIds });
        case type.UnselectedOption: {
            const fravalgtText = `- ${getTextRaw(line, i18n)} (${translate('fravalgt', i18n, 'common.excluded')})`;
            return { text: fravalgtText, textRaw: fravalgtText, indent };
        }
        case type.SelectedOption:
            return;
        case type.ReturnableItem:
            return line;
        case type.Discount:
            return line;
        case type.Voucher:
            return line;
        default:
            throw new Error('ShouldNeverHappen');
    }
};
const transformDescriptionKioskLineToDescription = (line, parentQuantity = 1, i18n) => {
    const getFields = (line, includePriceToken) => {
        const fields = {};
        const isMultiplied = parentQuantity > line.quantity;
        if (line.quantity)
            fields.quantity = line.quantity;
        if (line.totalPrice && !isMultiplied) {
            fields.price = Utils.formatPriceZero(line.totalPrice);
        }
        else if (line.price) {
            fields.price = Utils.formatPriceZero(isMultiplied ? line.price * parentQuantity : line.price);
        }
        if (includePriceToken && line.totalPrice) {
            fields.includePriceToken = Boolean(includePriceToken && line.totalPrice);
        }
        return fields;
    };
    const indent = line.indent;
    const type = ReceiptLineDescriptionEnum;
    switch (line.type) {
        case 'Aggregation':
            return Object.assign({ text: getTextKiosk(line), textRaw: getTextRaw(line), indent }, getFields(line));
        case 'Product':
            return Object.assign(Object.assign({ text: getTextKiosk(line, true, indent, i18n), textRaw: getTextRaw(line), indent }, getFields(line, true)), { productId: line.productId });
        case type.UnselectedOption: {
            const fravalgtText = `${getTextKiosk(line, false, indent, i18n)} (${translate('fravalgt', i18n, 'common.excluded')})`;
            return { text: fravalgtText, textRaw: fravalgtText, indent };
        }
        case type.ReturnableItem:
            return line;
        case type.Discount:
            return line;
        case type.Info:
            return line;
        case type.Voucher:
            return line;
        default:
            throw new Error('ShouldNeverHappen');
    }
};
const getText = (line, includePriceToken = false, i18n = null) => {
    const { quantity, name, totalPrice } = line;
    const defaultName = 'text' in line ? line.text : name;
    const effectiveName = getEffectiveName(defaultName, line, i18n);
    const priceToken = includePriceToken && totalPrice ? ` (+${Utils.formatPriceZero(totalPrice)})` : '';
    if (quantity === 1 || quantity === undefined) {
        return `${effectiveName}${priceToken}`;
    }
    else {
        return `${quantity} x ${effectiveName}${priceToken}`;
    }
};
const getTextKiosk = (line, includePriceToken = false, indent = 0, i18n = null) => {
    const { quantity, name } = line;
    const defaultName = 'text' in line ? `${line.text}` : `${name}`;
    const effectiveName = getEffectiveName(defaultName, line, i18n);
    const spacesAndHyphens = ' '.repeat(indent) + (indent ? '- ' : '');
    if (quantity === 1 || quantity === undefined) {
        return `${spacesAndHyphens}${effectiveName}`;
    }
    else {
        const quantityIndicator = `${quantity} x `;
        return `${spacesAndHyphens}${quantityIndicator}${effectiveName}`;
    }
};
export const mapToReceiptLineViewG5 = (receiptLines, i18n) => {
    return receiptLines.map((line) => {
        var _a;
        if (line.type === 'Meta') {
            return Object.assign(Object.assign({}, line), { objectType: 'ReceiptLineView', name: getText(line, false), description: [] });
        }
        const generateDescriptions = (lineDescription, skip, description = [], highlightDescription = []) => {
            if (!lineDescription || lineDescription.length === 0) {
                return {
                    description,
                    highlightDescription,
                };
            }
            return lineDescription
                .map((ld) => transformDescriptionLineToDescription(ld, i18n))
                .filter(Boolean)
                .reduce((acc, curr) => {
                if ([ReceiptLineDescriptionEnum.Voucher].includes(curr.type)) {
                    if (acc.highlightDescription.some((desc) => desc.text === curr.text)) {
                        return acc;
                    }
                    return Object.assign(Object.assign({}, acc), { highlightDescription: acc.highlightDescription.concat(curr) });
                }
                return Object.assign(Object.assign({}, acc), { description: acc.description.concat(curr) });
            }, { description, highlightDescription });
        };
        if (line.type === 'CombinatorLine') {
            return Object.assign(Object.assign(Object.assign({}, line), { generation: 5, objectType: 'ReceiptLineView', name: getText(line, true) }), generateDescriptions(line.description, true));
        }
        const subtractIntent2Prices = line.price > 0
            ? line.price
            : (line.totalPriceBefore || 0) - (((_a = line.description) === null || _a === void 0 ? void 0 : _a.reduce((sum, line) => sum + line.totalPrice, 0)) || 0);
        const newDescriptions = line.price && (line.quantity > 1 || ('usesMenuPrice' in line && line.usesMenuPrice))
            ? [
                {
                    text: translate('á', i18n, 'common.each') +
                        ' ' +
                        Utils.formatPriceZero(Math.max(line.price, subtractIntent2Prices)),
                    textRaw: 'á',
                    type: 'Info',
                    format: 'bold',
                },
            ]
            : [];
        if (line.type === 'Discount') {
            line.name = getOrderLineNameForDiscount(line);
        }
        return Object.assign(Object.assign(Object.assign({}, line), { objectType: 'ReceiptLineView', name: getText(line, false, i18n) }), generateDescriptions('description' in line && line.description, false, newDescriptions));
    });
};
export const mapToReceiptLineKioskViewG5 = (receiptLines, i18n) => {
    return receiptLines.map((line) => {
        if (line.type === 'Meta') {
            return Object.assign(Object.assign({}, line), { objectType: 'ReceiptLineKioskView', name: getTextKiosk(line, false), description: [] });
        }
        else if (line.type === 'CombinatorLine') {
            return Object.assign(Object.assign({}, line), { price: Utils.formatPriceZero(line.totalPrice), generation: 5, objectType: 'ReceiptLineKioskView', name: getTextKiosk(line, true), description: line.description
                    .map((descLine) => transformDescriptionKioskLineToDescription(descLine, line.quantity, i18n))
                    .filter((line) => line !== undefined) });
        }
        const newDescriptions = [];
        if ('description' in line && line.description) {
            newDescriptions.push(...line.description
                .map((descLine) => transformDescriptionKioskLineToDescription(descLine, line.quantity, i18n))
                .filter((line) => line !== undefined));
        }
        if (line.type === 'Discount') {
            line.name = getOrderLineNameForDiscount(line);
        }
        if (line.type === 'Product') {
            const hasVoucher = line && line.description && line.description.some((desc) => desc.type === 'Voucher');
            return Object.assign(Object.assign({}, line), { price: line.totalPrice && !hasVoucher
                    ? Utils.formatPriceZero(line.totalPrice)
                    : Utils.formatPriceZero(hasVoucher && line.totalPriceBefore ? line.totalPriceBefore : line.price), objectType: 'ReceiptLineKioskView', name: getTextKiosk(line, false, 0, i18n), description: !hasVoucher
                    ? newDescriptions
                    : newDescriptions.length &&
                        newDescriptions.map((desc) => {
                            if (desc.type === 'Voucher') {
                                const price = (line.priceBefore ? line.priceBefore - line.price : line.totalPriceBefore - line.totalPriceAccum) ||
                                    0;
                                return {
                                    text: ` - ${desc.text}`,
                                    textRaw: desc.text,
                                    type: 'Product',
                                    price: `-${formatPriceZero(price)}`,
                                    quantity: 1,
                                    includePriceToken: true,
                                };
                            }
                            return desc;
                        }) });
        }
        return Object.assign(Object.assign({}, line), { objectType: 'ReceiptLineKioskView', name: getTextKiosk(line, false, 0, i18n), description: newDescriptions });
    });
};
export const isVatReferenceInReceiptLines = (receiptLines) => {
    return receiptLines.some((receiptLine) => ('vatReference' in receiptLine && receiptLine.vatReference) ||
        (receiptLine.description || []).some((description) => 'vatReference' in description && description.vatReference));
};
export const mapToVatRatesPerCategory = (receiptLines) => {
    const vatRates = [];
    receiptLines.forEach((receiptLine) => {
        const usesMenuPrice = 'usesMenuPrice' in receiptLine ? receiptLine.usesMenuPrice : false;
        if (!usesMenuPrice) {
            const vatCategoryId = 'vatCategoryId' in receiptLine && receiptLine.vatCategoryId ? receiptLine.vatCategoryId : 0;
            const vatCategoryName = 'vatCategoryName' in receiptLine && receiptLine.vatCategoryName ? receiptLine.vatCategoryName : '';
            const vatReference = 'vatReference' in receiptLine && receiptLine.vatReference ? receiptLine.vatReference : '';
            const vatRatePerMille = 'vatRatePerMille' in receiptLine && receiptLine.vatRatePerMille ? receiptLine.vatRatePerMille : 0;
            const totalVat = 'totalVat' in receiptLine && receiptLine.totalVat ? receiptLine.totalVat : 0;
            if (totalVat) {
                const vatRatesIndex = vatRates.findIndex((vatRate) => vatRate.vatCategoryId === vatCategoryId);
                if (vatRatesIndex !== -1) {
                    vatRates[vatRatesIndex].totalVat += totalVat;
                    vatRates[vatRatesIndex].vats.push({ totalVat });
                }
                else {
                    vatRates.push({
                        vatCategoryId,
                        vatCategoryName,
                        vatReference,
                        vatRatePerMille,
                        totalVat,
                        vats: [{ totalVat }],
                    });
                }
            }
        }
        if (receiptLine.description.length) {
            receiptLine.description.forEach((description) => {
                const vatCategoryId = 'vatCategoryId' in description && description.vatCategoryId ? description.vatCategoryId : 0;
                const vatCategoryName = 'vatCategoryName' in description && description.vatCategoryName ? description.vatCategoryName : '';
                const vatReference = 'vatReference' in description && description.vatReference ? description.vatReference : '';
                const vatRatePerMille = 'vatRatePerMille' in description && description.vatRatePerMille ? description.vatRatePerMille : 0;
                const totalVat = 'totalVat' in description && description.totalVat ? description.totalVat : 0;
                if (totalVat) {
                    const vatRatesIndex = vatRates.findIndex((vatRate) => vatRate.vatCategoryId === vatCategoryId);
                    if (vatRatesIndex !== -1) {
                        vatRates[vatRatesIndex].totalVat += totalVat;
                        vatRates[vatRatesIndex].vats.push({ totalVat });
                    }
                    else {
                        vatRates.push({
                            vatCategoryId,
                            vatCategoryName,
                            vatReference,
                            vatRatePerMille,
                            totalVat,
                            vats: [{ totalVat }],
                        });
                    }
                }
            });
        }
    });
    return vatRates;
};
function getOrderLineNameForDiscount(line) {
    if (line.name === 'CartDiscount') {
        return discountTypeLocalization.CartDiscount;
    }
    if (discountTypeLocalization[line.tags[0]]) {
        return discountTypeLocalization[line.tags[0]];
    }
    return line.tags[0];
}
